import { EventBus } from '../../helpers';

type PlanComparisonTableEvents = {
  viewAllFeaturesExpanded: [];
  viewAllFeaturesCollapsed: [];
  scrollDepthReached: [featureName: string];
};

class PlanComparisonTableEventBus extends EventBus<PlanComparisonTableEvents> {}

export const planComparisonTableEventBus = new PlanComparisonTableEventBus();
